const displayInstanceName = (value) => {
  const text = String(value || "").trim();
  return text ? text.toUpperCase() : "—";
};

/** Compact Instância cell — gray, matches carteira GridHistory (no purple). */
export const BaasInstanceNameCell = ({ name, className = "" }) => (
  <p
    className={`truncate text-xs font-medium uppercase tracking-wide text-gray-600 dark:text-gray-300 ${className}`.trim()}
  >
    {displayInstanceName(name)}
  </p>
);
